module.exports = __webpack_public_path__ + "img/games-drone-shield.2b89d7a8.png";